import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { createGenerateClassName } from "@mui/styles";

import EntryWrapper from "./entry-wrapper";
import Discovery from "./../components/discovery";

const generateClassName = createGenerateClassName({
  productionPrefix: "dis",
});

const EntryDiscovery = document.getElementById("sa_content_filtering_entry-discovery");
ReactDOM.render(
  <EntryWrapper generateClassName={generateClassName}>
    <Router>
      <Discovery />
    </Router>
  </EntryWrapper>,
  EntryDiscovery
);

export default EntryDiscovery;
